
const GlowEffect = ({ direction = 'right' }: { direction?: string }) => {
  return (
    <div className={`absolute top-0 ${direction}-0 lg:${direction}-[-200px] w-[400px] lg:w-[678px] h-[400px] lg:h-[648px] opacity-85 animate-pulse -z-50`}>
      <div className="w-full h-full rounded-full bg-gradient-to-b from-[#1179F9] to-[#A6A0F6] blur-[300px] lg:blur-[321px]" />
    </div>
  );
};

export default GlowEffect;
